import React, { Component } from 'react';
import styled from 'styled-components';

// Redux
import { connect } from 'react-redux';
import * as actions from 'actions';
import { Link } from 'react-router-dom';

// Custom components
import CompanyInterfaceForm, {
    ComponentWrapper,
    FormWrapper,
    TopContainer,
} from 'containers/CompanyContainer/CompanyInterfaceForm';
import FormTextField from 'containers/CompanyContainer/Forms/Components/FormTextField';
import CompanyPageButton from 'containers/CompanyContainer/CompanyPageButton';
import FormSelectField from 'containers/CompanyContainer/Forms/Components/FormSelectField';
import selectOptions from 'containers/CompanyContainer/Forms/Options';
import FormCheckboxField from 'containers/CompanyContainer/Forms/Components/FormCheckboxField';
import { getLocalTimestampFromDateString } from 'utils/timezoneUtils';

// Constants
import { constants } from 'constants/index';

const InstructionsWrapper = styled.div`
    font: 24px Open Sans, Helvetica, sans-serif;
    color: ${constants.color.grey34};
`;

class AccountActivationForm extends CompanyInterfaceForm {
    state = {
        email: '',
        firstName: '',
        lastName: '',
        provinceOfResidence: '',
        phone: '1',
        dateOfBirthTimestamp: null,
        formValidationErrors: {},
        hasAgreedToTerms: false,
        hasConsentedToMarketing: false,
    };

    componentDidMount = () => {
        const { userData, authData } = this.props;
        const email = authData.email;
        const firstName = userData && userData.firstName;
        const lastName = userData && userData.lastName;
        const phone = userData && userData.phone;
        this.setState({
            email,
            firstName,
            lastName,
            phone,
        });
    };

    handleForm = event => {
        event.preventDefault();
        const activationFormData = this.formatDataForDB();
        // TODO implement error display
        this.props.completeAccountActivationForm(activationFormData);
    };

    checkValidation = ({ event, type, parent, index }) => {
        const { name, value } = event.target;
        const errorMessage = this.validateInput({
            type,
            value: event.target.value,
        });
        let formValidationErrors = { ...this.state.formValidationErrors };

        formValidationErrors[name] = errorMessage;

        this.setState({ formValidationErrors });
    };

    formatDataForDB = () => {
        const {
            firstName,
            lastName,
            provinceOfResidence,
            phone,
            dateOfBirthTimestamp,
            hasAgreedToTerms,
            hasConsentedToMarketing,
        } = this.state;

        const isProvinceOfResidenceEmpty = value =>
            value === '' ? true : false;

        const dateElements = dateOfBirthTimestamp.split('-'); // FORMAT YYYY-MM-DD
        const formattedDateOfBirthTimestamp = getLocalTimestampFromDateString(
            dateElements[2],
            dateElements[1],
            dateElements[0],
        );
        const formattedActivationData = {
            basicProfile: {
                firstName,
                lastName,
            },
            provinceOfResidence: isProvinceOfResidenceEmpty(provinceOfResidence)
                ? constants.option.provinces[0]['value']
                : provinceOfResidence,
            dateOfBirthTimestamp: formattedDateOfBirthTimestamp,
            hasAgreedToTerms,
            hasConsentedToMarketing,
            codeActivated: true, // SET TO TRUE AS YOU CAN ONLY ACCESS THIS FORM BY ADDING THE CORRECT CODE
        };
        return formattedActivationData;
    };

    render() {
        const {
            email,
            firstName,
            lastName,
            provinceOfResidence,
            dateOfBirthTimestamp,
            phone,
            hasAgreedToTerms,
            hasConsentedToMarketing,
        } = this.state;

        const { userData } = this.props;

        return (
            <ComponentWrapper>
                <FormWrapper onSubmit={this.handleForm}>
                    <TopContainer>
                        <CompanyPageButton
                            test-label="saveButton"
                            type={'dark'}
                            size={'small'}
                            children={'Submit information'}
                        />
                    </TopContainer>
                    <h1>Activation form</h1>
                    <FormTextField
                        label="Email"
                        value={email}
                        disabled={true}
                    />
                    <FormTextField
                        label="First name"
                        name="firstName"
                        onChange={this.handleChange}
                        disabled={userData && userData.firstName ? true : false}
                        value={firstName}
                        required={true}
                        onfocusout={event =>
                            this.checkValidation({
                                event,
                                type: 'name',
                            })
                        }
                    />
                    <FormTextField
                        label="Last name"
                        name="lastName"
                        onChange={this.handleChange}
                        disabled={userData && userData.lastName ? true : false}
                        value={lastName}
                        required={true}
                        onfocusout={event =>
                            this.checkValidation({
                                event,
                                type: 'name',
                            })
                        }
                    />
                    <FormTextField
                        label="Phone number"
                        name="phone"
                        onChange={this.handleChange}
                        disabled={userData && userData.phone ? true : false}
                        value={this.phoneInputMask(phone)}
                        required={true}
                        onfocusout={event =>
                            this.checkValidation({
                                event,
                                type: 'phone',
                            })
                        }
                    />
                    <FormSelectField
                        label="Province of residence"
                        name={'provinceOfResidence'}
                        onChange={this.handleSelectChange}
                        value={provinceOfResidence}
                        options={constants.option.provinces}
                        displayKey={'label'}
                        valueKey={'value'}
                        required={true}
                    />
                    <h3>Birthday</h3>
                    <input
                        type="date"
                        name="dateOfBirthTimestamp"
                        onChange={this.handleChange}
                        required={true}
                    />
                    <FormCheckboxField
                        label="I agree to receive service suggestions, company updates and other promotions from Cyno. You can withdraw your consent at any time in account settings or via the link in the message."
                        name="hasConsentedToMarketing"
                        onChange={this.handleChange}
                        value={hasConsentedToMarketing}
                        containerProps={{
                            border: 'none',
                            background: 'transparent',
                            marginTop: '10px',
                        }}
                        labelProps={{
                            fontSize: '12px',
                        }}
                    />
                    <FormCheckboxField
                        label={
                            <span>
                                I have read and agree to Cyno’s&nbsp;
                                <Link
                                    to="/terms_and_conditions"
                                    target="_blank"
                                    style={{
                                        color: 'lightblue',
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Terms&nbsp;Of&nbsp;Use
                                </Link>
                                <span> </span>and<span> </span>
                                <Link
                                    to="/privacy_policy"
                                    target="_blank"
                                    style={{
                                        color: 'lightblue',
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Privacy&nbsp;Policy
                                </Link>
                                .
                            </span>
                        }
                        name="hasAgreedToTerms"
                        onChange={this.handleChange}
                        value={hasAgreedToTerms}
                        required={true}
                        containerProps={{
                            border: 'none',
                            background: 'transparent',
                            marginTop: '10px',
                        }}
                        labelProps={{
                            fontSize: '12px',
                        }}
                    />
                </FormWrapper>
            </ComponentWrapper>
        );
    }
}

const mapStateToProps = ({ auth, client }) => ({
    authData: auth.authData,
    userData: client.clientData,
});

export default connect(
    mapStateToProps,
    actions,
)(AccountActivationForm);



// WEBPACK FOOTER //
// ./src/js/containers/AccountActivation/AccountActivationForm.jsx